import React from "react";
import { Button, Card } from "react-bootstrap";

const TicketOptionCard = ({
  title,
  badges = [],
  description,
  extraContent = null,
  priceLabel,
  priceClassName = "",
  soldOut = false,
  isInCart = false,
  actionDisabled = false,
  onAction,
}) => (
  <Card
    className="p-2 mb-3 shadow-sm md:py-6 md:px-9"
  >
    <Card.Body>
      <div className="flex flex-col gap-3 md:flex-row justify-content-between align-items-start" style={{ opacity: actionDisabled ? 0.5 : 1 }}>
        <div>
          <div className="mb-3 text-base">{title}</div>
          {badges.length > 0 && (
            <div className="flex flex-wrap gap-1 text-muted">
              {badges.map((badgeLabel, index) => (
                <div
                  key={`${title}-${badgeLabel}-${index}`}
                  className="p-1 text-xs bg-blue-100 rounded"
                >
                  {badgeLabel}
                </div>
              ))}
            </div>
          )}
          {description && <div className="mt-4 small text-muted">{description}</div>}
        </div>
        <div className="flex flex-col flex-shrink-0 md:gap-3 md:items-end">
          {priceLabel && (
            <div className={priceClassName + " text-base font-bold pb-2"}>
              {priceLabel}
            </div>
          )}
          {isInCart ? (
            <Button
              disabled={actionDisabled}
              onClick={onAction}
              className="theme-btn-red"
            >
              Remove Order
            </Button>
          ) : (
            <Button
              disabled={actionDisabled}
              onClick={onAction}
              className="theme-btn"
            >
              {soldOut ? "Sold Out" : "Add Order →"}
            </Button>
          )}
        </div>
      </div>
      {extraContent && <div className="mt-3">{extraContent}</div>}
    </Card.Body>
  </Card>
);

export default TicketOptionCard;
